// src/components/Gallery/Lightbox/LightboxInfo.js
import React from 'react';

const LightboxInfo = ({ 
  artwork, 
  isMobile, 
  isTrueLandscape,
  isLandscapeSidePanel = false 
}) => {
  
  if (isTrueLandscape && !isLandscapeSidePanel) {
    // Bottom info bar for landscape fullscreen
    return (
      <div
        style={{
          position: 'absolute',
          bottom: '8px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'rgba(255,255,255,0.9)',
          color: 'rgb(33, 37, 41)',
          padding: '8px 16px',
          borderRadius: '20px',
          fontSize: '11px',
          textAlign: 'center',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(0,0,0,0.1)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          maxWidth: '80%',
          zIndex: 2001
        }}
      >
        <div style={{ 
          fontWeight: '500', 
          marginBottom: '2px',
          fontFamily: 'Georgia, serif'
        }}>
          {artwork.title}
        </div>
        <div style={{ 
          opacity: 0.8,
          color: 'rgb(108, 117, 125)',
          fontFamily: 'system-ui, sans-serif'
        }}>
          {artwork.year} • {artwork.medium} • {artwork.dimensions}
        </div>
      </div>
    );
  }

  if (isLandscapeSidePanel) {
    // Side panel for landscape layout
    return (
      <div
        style={{
          textAlign: 'left',
          color: 'rgb(33, 37, 41)',
          maxWidth: '200px',
          flexShrink: 0,
          padding: '10px',
          background: 'rgba(255,255,255,0.8)',
          borderRadius: '8px',
          backdropFilter: 'blur(5px)'
        }}
      >
        <div
          style={{
            fontSize: '14px',
            fontWeight: '500',
            marginBottom: '4px',
            fontFamily: 'Georgia, serif',
            lineHeight: '1.2'
          }}
        >
          {artwork.title}
        </div>
        <div
          style={{
            fontSize: '11px',
            color: 'rgb(108, 117, 125)',
            fontFamily: 'system-ui, sans-serif',
            lineHeight: '1.3'
          }}
        >
          {artwork.year}
          <br />
          {artwork.medium}
          <br />
          {artwork.dimensions}
        </div>
      </div>
    );
  }

  // Standard bottom info for portrait/desktop
  return (
    <div
      style={{
        marginTop: isMobile ? '12px' : '20px',
        textAlign: 'center',
        color: 'rgb(33, 37, 41)',
        maxWidth: '90%'
      }}
    >
      <div
        style={{
          fontSize: isMobile ? '14px' : '18px',
          fontWeight: '500',
          marginBottom: '4px',
          fontFamily: 'Georgia, serif'
        }}
      >
        {artwork.title}
      </div>
      <div
        style={{
          fontSize: isMobile ? '11px' : '14px',
          color: 'rgb(108, 117, 125)',
          fontFamily: 'system-ui, sans-serif'
        }}
      >
        {artwork.year} • {artwork.medium} • {artwork.dimensions}
      </div>

      {/* Video Indicator */}
      {artwork.mediaType === 'video' && (
        <div
          style={{
            position: 'absolute',
            top: isMobile ? '8px' : '8px',
            right: isMobile ? '8px' : '8px',
            color: '#495057',
            fontSize: isMobile ? '10px' : '12px',
            background: 'rgba(255,255,255,0.9)',
            padding: isMobile ? '4px 8px' : '4px 8px',
            borderRadius: '12px',
            border: '1px solid rgba(0,0,0,0.1)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px'
          }}
        >
          ▶ Video
        </div>
      )}
    </div>
  );
};

export default LightboxInfo;